import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoginConstants } from '../constants/login.constants';
import {IToken} from '@app/shared.module/models/index';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) {
  }

  login(data: any): Observable<IToken> {
    let body = new HttpParams();
    body = body.set('token', data['token']);
    body = body.set('username', data['userName']);
    body = body.set('password', data['password']);
    body = body.set('grant_type', 'password');
    const options = {
      headers: new HttpHeaders({
          noToken: 'noToken'
      })
  };
    return this.http
    .post<IToken>(`${LoginConstants.baseUrl}${LoginConstants.apiEndPoints.login}`, body, options);
  }

}
